export default __webpack_public_path__ + "static/media/orbithman.95b4f110.gif";